import React, { useEffect, useState, useContext } from "react";
import tmdbApi from "../../api/tmdbApi";
import LandingHeader from "../../components/LandingHeader/Header";
import LandingFooter from "../../components/footer/LandingFooter";
import InsideHeader from "../../components/InnerHeader/Header";
import SessionPopup from "../SessionPopup";
import axios from "axios";
import moment from "moment";
import { contentContext } from "../../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import 'react-toastify/dist/ReactToastify.css';
import InactivePopup from "../inactivePopup";
let { lambda, appname } = window.app;
const Contact = () => {
  const [config, setConfig] = useState({});
  const [emailError, setEmailError] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [nameerror, setNameError] = useState('');
  const [subject, setSubject] = useState('');
  const [msg, setMsg] = useState('');
  const [errmsg, setErrmsg] = useState('');
  const [suberror, setSubError] = useState('');
  const [success, setSuccess] = useState('');
  // const [clientData, setClientData] = useState([]);
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const [activeCheckId, setActiveCheckId] = useState("");
  const [emailCopied, setEmailCopied] = useState(false);
  const [phoneCopied, setPhoneCopied] = useState(false);

  const { menus, setContentSearchFlag, inactiveFlag, setInactiveFlag, contentSearchFlag, clientData, setClientData, setRoute } = useContext(contentContext);
  const subjectOptions = [
    { value: "", label: "Subject" },
    { value: "general", label: "General Inquiry" },
    { value: "support", label: "Technical Support" },
    { value: "partnership", label: "Partnership" },
    { value: "media", label: "Media Inquiry" },
    { value: "aidubbing", label: "AI Dubbing" },
    { value: "ailicensing", label: "AI Licensing" },
  ];

  useEffect(() => {
    // appMenus();
    if (localStorage.getItem("token")) {
      // GetClientDataFun();
      clientActivity()
    }
    setContentSearchFlag(false)
    setRoute("notcontent")
  }, []);



  const clientActivity = () => {
    let path = window.location.pathname.split("/");
    // const pageName = path[path.length - 1];
    var presentTime = moment();
    let payload;

    payload = {
      "clientid": localStorage.getItem("clientid"),
      "pagename": 'CONTACT US',
      "pageurl": window.location.href,
      "starttime": presentTime,
      "useragent": JSON.parse(localStorage.getItem("loc"))

    };


    let urlLink;
    if (localStorage.getItem("previousid")) {
      urlLink = lambda + '/activity?appname=' + appname + "&previousid=" + localStorage.getItem("previousid")
    } else {
      urlLink = lambda + '/activity?appname=' + appname
    }

    axios({
      method: 'POST',
      url: urlLink,
      data: payload
    })
      .then(function (response) {
        if (response.data.statusCode === 200) {
          localStorage.setItem("previousid", response.data.result)
        }
      });
  }

  const validateEmail = (e) => {

    setEmail(e.target.value);

  }

  function formvalidation() {

    let flag = true;
    if (localStorage.getItem("clientid")) {
      if (msg === "") {
        setErrmsg("Please enter Message");
        setTimeout(function () { setErrmsg("") }, 3000);
        flag = false;

        return;
      }
    } else {
      const regEx = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}(.[a-zA-Z{2,8}])?/g;
      if (regEx.test(email)) {
        setEmailError("");
        setTimeout(function () { setEmailError("") }, 2000)
      } else if (!regEx.test(email) && email !== "") {
        setEmailError("Email is Not Valid");
        flag = false;

      }

      if (name == "") {
        setNameError("Please Enter Name");
        flag = false;

        return;
      }

      if (email == "") {
        setEmailError("Please Enter Email");
        flag = false;

        return;
      }
      if (subject == "") {
        setSubError("Please Enter Subject");
        flag = false;

        return;
      }
      if (msg === "") {
        setErrmsg("Please Enter Message");
        flag = false;

        return;
      }
    }
    // console.log('subject',subject)
    if (flag) {
      if (activeCheckId == "") {
        handleContactus();
      }
    } else {
      setActiveCheckId("")
    }

    return;
  }
  const AddNotify = () => toast.success('Your message has been sent. Thank you!', {
    position: "bottom-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  },)
  const ShowError = () => toast.error('Sorry something Went Wrong, Please try again.', {
    position: "bottom-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  },)
  const handleContactus = async () => {
    try {
      setActiveCheckId("isload")
      if (clientData && clientData.name) {
        const response = await tmdbApi.ClientContactus({
          "name": clientData && clientData.name ? clientData.name : name,
          "emailid": clientData && clientData.personalemail ? clientData.personalemail : email,
          "subject": subject,
          "message": msg
        });
        console.log(response);
        if (response.statusCode == 200) {
          if (response.result == "Invalid token or Expired") {
            setShowSessionPopupup(true)
          } else if (response.result == "Client inactived") {
            setInactiveFlag(true)

          } else {
            AddNotify()
            setActiveCheckId("")
            // setSuccess("Your message has been sent. Thank you!");
            setName("");
            setEmail("");
            setSubject("");
            setMsg("");
            setTimeout(function () {
              setSuccess("");
            }, 3000);
          }
        }
      } else {
        const response = await tmdbApi.contactus({
          "name": name,
          "emailid": email,
          "subject": subject,
          "message": msg
        });
        console.log(response);
        if (response.statusCode == 200) {
          setActiveCheckId("")
          AddNotify()
          // setSuccess("Your message has been sent. Thank you!");
          setName("");
          setEmail("");
          setSubject("");
          setMsg("");
          setTimeout(function () {
            setSuccess("");
          }, 3000);
        }
      }

    } catch {
      ShowError()

      setActiveCheckId("")
      console.log("error");
    }
  };


  const handleSubmit = (e) => {
    formvalidation();
  }
  const handleName = (e) => {
    setNameError("");
  }

  const handleEmail = (e) => {
    setEmailError("");
  }

  const handleSubject = (e) => {
    setSubError("");
  }

  const handleMessage = (e) => {
    setErrmsg("");
  }


  let img = window.app.img;
  useEffect(() => {
    if (window.site) {
      setConfig(window.site);

    }

  }, [window.site]);

  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text);

    if (type === "email") {
      setEmailCopied(true);
      setTimeout(() => setEmailCopied(false), 1000);
    } else {
      setPhoneCopied(true);
      setTimeout(() => setPhoneCopied(false), 1000);
    }
  };

  if (config.common && config.common.imagesCDN) {
    img = config.common.imagesCDN;
  }
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#111111",
      borderColor: "#2c2c2c",
      boxShadow: "none",
      "&:hover": { borderColor: "#2c2c2c" },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#292929", // menu background
    }),

    menuList: (provided) => ({
      ...provided,
      backgroundColor: "#292929", // list background
    }),
    menu: (provided) => ({
      ...provided,
      // keep default scroll and dropdown behavior
    }),
    // no need to override indicators or other components
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "rgb(104, 104, 104)",           // change indicator (arrow) color
      "&:hover": { color: "rgb(104, 104, 104)" },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#020202 !important", // keep chip dark
      border: "1px solid #444444",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#ffffff",
      backgroundColor: "#020202",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#ffffff",
      fontSize: "12px",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#ffffff",
      backgroundColor: "#020202",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "#020202",
        color: "#ffffff",
      },
    }),
  };
  const handleChange = (selectedOption) => {
    setSubject(selectedOption?.value || ""); // store value directly in state
  };
  return (
    <>

      {localStorage.getItem("token") ? <InsideHeader activeClass={"7"} /> : <LandingHeader />}
      {inactiveFlag && <InactivePopup />}
      {!inactiveFlag && showSessionPopupup && <SessionPopup />}
      <section className="contact-hero-section">
        <div className="container-fluid">
          <div className="contact-hero-container">
            <div className="contact-hero-content">
              <div className="contact-hero-text-wrapper">
                <p className="contact-hero-subtitle">Contact Us</p>
                <h1 className="contact-hero-title">Let's Get in Touch</h1>
              </div>
              {/* <p className="contact-hero-description">
                        Lorem aliquip pariatur amet sunt occaecat elit ea eu aute. Irure in aliqua id dolor dolor proident officia labore aliqua aute velit labore excepteur quis.
                    </p> */}
            </div>
          </div>
        </div>
      </section>


      <section className="contact-main-section">
        <div className="container-fluid">

          <div className="contact-header-section">
            <div className="contact-header-content">
              <div className="contact-header-wrapper">
                <h2 className="contact-section-title">Contact Now</h2>
                <p className="contact-section-description">
                  If you would like to learn more about the platform or have other enquiries, here are the different ways we can be contacted.
                </p>
              </div>
              <div className="contact-email-wrapper">
                <span className="material-icons" style={{ color: "#fff" }}>email</span>
                <span className="contact-email-text" id="emailText">info@orasimedia.com</span>

                <span
                  className="material-icons copy-icon"
                  onClick={() => handleCopy("info@orasimedia.com", "email")}
                  style={{ cursor: "pointer" }}
                >
                  {emailCopied ? "check" : "content_copy"}
                </span>
              </div>

              <div className="contact-email-wrapper" >
                <span className="material-icons" style={{ color: "#fff" }}>phone</span>
                <span className="contact-email-text" id="phoneText">+1 (201) 633 8748</span>

                <span
                  className="material-icons copy-icon"
                  onClick={() => handleCopy("+12016338748", "phone")}
                  style={{ cursor: "pointer" }}
                >
                  {phoneCopied ? "check" : "content_copy"}
                </span>
              </div>


            </div>
          </div>


          <div className="contact-content-section">
            <div className="row">

              <div className="col-lg-6">
                <form className="contact-form">









                  {localStorage.getItem("clientid") ? (
                    <>

                      <div className="contact-form-group">
                        <label for="name" className="contact-form-label">Name</label>

                        <input
                          type="text"
                          className="contact-form-control"
                          name="name"
                          id="name-input-readonly"
                          placeholder="Your Name"
                          value={clientData.name}
                          required
                          disabled
                        />
                      </div>

                      <div className="contact-form-group">
                        <label for="email" className="contact-form-label">Email</label>
                        <input type="text" id="email" className="contact-form-control" name="emailid" value={clientData.personalemail}
                          disabled placeholder="Your Email" />

                      </div>
                    </>
                  ) : (
                    <>


                      <div className="contact-form-group">
                        <label for="name" className="contact-form-label">Name</label>

                        <input
                          type="text"
                          id="name-input"
                          name="name"
                          className="contact-form-control"
                          placeholder="Your Name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          autoComplete="on"
                          onFocus={(e) => handleName(e)}

                        />
                        {nameerror !== "" ? (
                          <span className="errormsg" id="name-error">
                            {nameerror}
                          </span>
                        ) : null}
                      </div>

                      <div className="contact-form-group">
                        <label for="email" className="contact-form-label">Email</label>
                        <input type="text" className="contact-form-control" id="email-input"

                          value={email}
                          onChange={(e) => validateEmail(e)}
                          onFocus={(e) => handleEmail(e)}
                          autoComplete="on"
                          placeholder="Your Email" />
                        <span className="errormsg" id="email-error">{emailError}</span>

                      </div>
                    </>
                  )}
                  <div className="contact-form-group">
                    <label for="subject" className="contact-form-label">Subject</label>
                    {/* <select name="subject" className="contact-form-control contact-form-select" value={subject} id="subject-input"
                      onChange={(e) => setSubject(e.target.value)}
                      onFocus={(e) => handleSubject(e)}>
                      <option value="">Subject</option>
                      <option value="general">General Inquiry</option>
                      <option value="support">Technical Support</option>
                      <option value="partnership">Partnership</option>
                      <option value="media">Media Inquiry</option>
                      <option value="aidubbing">AI Dubbing</option>
                      <option value="ailicensing">AI Licencing</option>
                    </select> */}
                    <Select
                      id="subjectDropdown"
                      value={subjectOptions.find(
                        (option) => option.value === subject
                      )}
                      onChange={handleChange}
                      options={subjectOptions}
                      styles={customStyles}
                      isMulti={false}
                      placeholder="Select Subject"
                    />
                    <span className="errormsg" id="subject-error">{suberror}</span>
                  </div>

                  <div className="contact-form-group">
                    <label for="message" className="contact-form-label">Message</label>
                    <textarea name="message" className="contact-form-control contact-form-textarea" rows="5" placeholder="Your message here..." id="message-input" value={msg}
                      onChange={(e) => setMsg(e.target.value)}
                      onFocus={(e) => handleMessage(e)}
                      required  ></textarea>
                    {errmsg !== "" ? (
                      <span className="errormsg" id="message-error">{errmsg}</span>
                    ) : null}
                  </div>

                  {success !== "" ? (
                    <span className="errormsg" style={{ color: "green" }} id="form-success">{success}</span>
                  ) : null}

                  {/* 
        <button  ><span>Send</span><span class="material-icons">arrow_forward</span></button>     */}

                </form>

                <button className="custom-btn-primary" id="custom-send-button"
                  onClick={(e) => handleSubmit(e)}>
                  {activeCheckId === "isload" ? (
                    <img
                      src={img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"}
                      className="loading-icon"
                      id="submit-loading-icon"
                    />
                  ) : null}  <span> Send</span>
                  <span className="material-icons">arrow_forward</span>
                </button>
              </div>
              <div className="col-lg-6">
                <div className="contact-map-container">
                  <div className="contact-map-placeholder">
                    <iframe id="map-iframe" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.9626926871138!2d-74.03727382411668!3d40.71883777139249!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c250abe95d4139%3A0x4e5a52eec3d304e!2sPlaza%205%2C%20185%20Hudson%20St%20%232500%2C%20Jersey%20City%2C%20NJ%2007311%2C%20USA!5e0!3m2!1sen!2sin!4v1756198185705!5m2!1sen!2sin" style={{ border: "0", width: "100%", height: "478px" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                  </div>
                  <div className="contact-address-info">
                    <p className="company-name">Orasi Media Inc.</p>
                    <p className="company-address">Harborside Financial Center, 185 Hudson St, Ste 2500, Jersey City, NJ 07311</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ToastContainer
            position="bottom-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
            theme="light"
          />
        </div>
      </section>
      <LandingFooter menus={menus} />
    </>
  );
};

export default Contact;
